import { useOnMousedownOutside } from 'base/ui/menu';
import { PlacementFunction, usePinElementPlacement } from 'base/ui/tooltip';
import { useLiveRef } from 'base/useLiveRef';
import { default as React } from 'react';
import { SIDEBAR_WIDTH_PX } from '../sidebar';
import styles from './floating_panel.css';
import { CommentingUiStore } from './ui_store';

export function FloatingCommentPanel({
  anchorTo,
  onClose,
  store,
  children,
}: {
  anchorTo: HTMLElement | null;
  onClose: () => void;
  store: CommentingUiStore;
  children: React.ReactNode;
}) {
  const ref = React.useRef<HTMLDivElement>(null);
  const anchorToRef = useLiveRef(anchorTo);
  usePinElementPlacement(
    true,
    anchorToRef,
    ref,
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useCallback(makePlaceAroundCommentPin(store), [store]),
  );
  const onMousedownOutsideProps = useOnMousedownOutside(
    true,
    onClose,
    anchorToRef,
  );

  // Panel has no anchor and cannot be rendered
  if (anchorTo == null) {
    return null;
  }

  return (
    <div className={styles.panel} ref={ref} {...onMousedownOutsideProps}>
      {children}
    </div>
  );
}

const makePlaceAroundCommentPin =
  (store: CommentingUiStore): PlacementFunction =>
  (anchor, content, contentEl) => {
    const pad = 8;
    // Makes the empty "Add a comment" state look centered with the comment pin.
    // We don't want it to jump around after that.
    const centerYOffeset = -7;
    const top = anchor.top + centerYOffeset;
    const openRight =
      anchor.right + content.width >
      window.innerWidth - (store.addMode ? SIDEBAR_WIDTH_PX : 0) - 16;
    const left = Math.max(
      openRight ? anchor.left - content.width - pad : anchor.right + pad,
      pad,
    );

    contentEl.style.top = top + 'px';
    contentEl.style.left = left + 'px';
  };
